$(function () {
  $('.news-item-container').imagesLoaded().progress(function () {
    initMasonry();
  });
  if ($('.hide-more-btn').length) {
    $('.btn-load-news-items').hide();
  }
  $('.btn-load-news-items').on('click', function (e) {
    e.preventDefault();
    var page = $(this).data("page");
    page++;
    getNewsItems(page);
    $(this).data("page", page);
  });
  var items = $(".newsListComponent-item");
});

// implement callback when lazy loaded images are done
function ll_finish_impl(args) {
  if (typeof initMasonry === "function") {
    initMasonry();
  }
}
function getNewsItems(page) {
  var sitecoreItem = $("body").data("sc-item");
  var sitecoreLanguage = $("body").data("sc-language");
  $.get("/get-newsitems?page=" + page + "&sitecoreItemId=" + sitecoreItem + "&sitecoreLanguageId=" + sitecoreLanguage, function (data) {
    var $items = $(data);
    $('.news-item-container').append($items);
    $('.news-item-container').masonry('appended', $items, true);
    $('.news-item-container').imagesLoaded().progress(function () {
      initMasonry();
    });
    if (!data || !data.trim() || $('.hide-more-btn').length) {
      $('.btn-load-news-items').hide();
    }
  });
}
function initMasonry() {
  $('.news-item-container').masonry({
    itemSelector: '.grid-item'
  });
}